import React, { Fragment, useEffect } from 'react';
import { Route, Routes, useLocation, useParams } from 'react-router-dom';
import TestPage from './testing';
import Trainings from './Trainings';
import Assessments from './Assessments';
import AssessmentsTest from './Assessments/AssessmentsTest';
import Testcomp from './Testcomp';
import Home from './Home/Home';
import NotFound from '../components/NotFound';
import { Container } from 'reactstrap';
import Waiting from '../components/waiting';
import { observer } from 'mobx-react';
import Question from './Question';
import { useStores } from '../hooks/use-stores';

const management_url = import.meta.env.REACT_APP_LMS_URL;

// Helper component for manager redirect
const ManagerRedirect = ({ url }) => {
    useEffect(() => {
        window.location = url;
    }, [url]);
    return null;
};
function AppRouting({ appLoading, currentCompany, companyId }) {

    const {authStore} = useStores();
    const {
        isGuest,
    } = authStore;
    const location = useLocation();


    useEffect(() => {
        if ( (location.pathname === "" || location.pathname === "/")  && isGuest){
            authStore.forgetUser();
        }
    }, [location]);



    return (
        <Fragment>
            {!appLoading ? (
                <Routes>
                    {import.meta.env.REACT_APP_TESTING && (
                        <Route path="/testing" element={<TestPage />} />
                    )}
                    <Route
                        path="trainings/*"
                        element={
                            <Trainings
                                isTrainingEnabled={
                                    currentCompany &&
                                    currentCompany.isTrainingEnabled
                                }
                                currentCompany={currentCompany}
                                companyId={companyId}
                            />
                        }
                    />
                    <Route
                        path="/assessments/*"
                        element={
                            <Assessments
                                isAssessmentEnabled={
                                    currentCompany &&
                                    currentCompany.isAssessmentEnabled
                                }
                                currentCompany={currentCompany}
                                companyId={companyId}
                            />
                        }
                    />
                    <Route
                        path="/assessment/question/:id"
                        element={<Question companyId={companyId} />}
                    />
                    <Route
                        path="/assessment/playground"
                        element={<AssessmentsTest />}
                    />
                    <Route path="/testcomp" element={<Testcomp />} />
                    <Route index element={<Home />} />
                    <Route
                        path="/manager"
                        element={<ManagerRedirect url={management_url} />}
                    />
                    {/* Finally, catch all unmatched routes */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            ) : (
                <Container className="main-content">
                    <Waiting waitingActive={appLoading} key={'Approuting'} />
                </Container>
            )}
        </Fragment>
    );
}

export default observer(AppRouting);
